export const OFFERS_STATUS_CONST = {
  PRODUCT_ACCEPTED: {
    CODE: 2,
    DESCRIPTION: 'Vitrina con producto en alta',
  },
  REFUSE: {
    CODE: 3,
    DESCRIPTION: 'Vitrina rechazada por el cliente',
  },
  REFUSE_ONBOARDING: {
    CODE: 7,
    DESCRIPTION: 'Cliente dio de alta producto por onboarding normal no desde vitrina',
  },
};
